var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveMatches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "white",
    stroke: "#D9622A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10066_333771",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 13.625V3.375H4.375V13.625H14.625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10066_333771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0996 13.6777H6.90039C6.18846 13.6777 5.61133 13.1006 5.61133 12.3887V7.83399H13.3887V12.3887C13.3887 13.1006 12.8115 13.6777 12.0996 13.6777Z",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61133 9.76758C4.8994 9.76758 4.32227 9.19044 4.32227 8.47852C4.32227 8.12256 4.61084 7.83398 4.9668 7.83398H5.61133",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3887 9.76758C14.1006 9.76758 14.6777 9.19044 14.6777 8.47852C14.6777 8.12256 14.3892 7.83398 14.0332 7.83398H13.3887",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26745 5.33209L8.1327 5.03937C7.90941 4.55434 8.12159 3.98015 8.60662 3.75686C9.09163 3.53359 9.66582 3.74577 9.88911 4.23078L10.0239 4.52353",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63281 6.54492L12.6585 3.32227",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6121 4.72191C12.6121 4.72191 12.1563 4.72191 11.9284 4.94979C11.7006 5.17766 11.7006 5.6334 11.7006 5.6334C11.7006 5.6334 11.7006 6.08917 11.4727 6.31704C11.2448 6.54492 10.7891 6.54492 10.7891 6.54492",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5457 4.72191C14.5457 4.72191 14.0899 4.72191 13.862 4.94979C13.6342 5.17766 13.6342 5.6334 13.6342 5.6334C13.6342 5.6334 13.6342 6.08917 13.4063 6.31704C13.1784 6.54492 12.7227 6.54492 12.7227 6.54492",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMatches);
export default __webpack_public_path__ + "static/media/active-matches.3f199c17ab5a59d52996016c1e28cdfa.svg";
export { ForwardRef as ReactComponent };